import { Pencil, Highlighter, Brush, Eraser, PaintBucket, Sticker } from "lucide-react";
import { PALETTE, STICKERS } from "../../lib/art";

const CrayonIcon = () => (
  <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round"><path d="M4 20l3-1 12-12-2-2L5 17z" /><path d="M14 6l4 4" /><path d="M8 16l-2-2" /></svg>
);

const TOOLS = [
  ["pencil", "鉛筆", Pencil], ["crayon", "蠟筆", CrayonIcon], ["marker", "麥克筆", Highlighter], ["brush", "水彩筆", Brush],
  ["fill", "倒顏料", PaintBucket], ["sticker", "貼紙", Sticker], ["eraser", "橡皮擦", Eraser],
];
const SIZES = [[8, "細"], [18, "中"], [32, "粗"]];

export const Toolbar = ({ tool, setTool, color, setColor, size, setSize, sticker, setSticker }) => (
  <div className="w-full md:w-64 lg:w-72 shrink-0 rounded-3xl bg-white/90 border-2 border-[#f3d9b8] p-3 space-y-3 shadow-sm" data-testid="draw-toolbar">
    <div className="grid grid-cols-4 md:grid-cols-3 gap-2">
      {TOOLS.map(([k, label, Icon]) => (
        <button key={k} data-testid={`draw-tool-${k}`} onClick={() => setTool(k)} aria-pressed={tool === k}
          className={`h-14 md:h-16 rounded-2xl flex flex-col items-center justify-center gap-0.5 text-sm font-bold transition-transform active:scale-95 ${tool === k ? "bg-[#E2683C] text-white shadow-md -translate-y-0.5" : "bg-[#FFF5E8] text-stone-700"}`}>
          <Icon /><span>{label}</span>
        </button>
      ))}
    </div>
    {tool === "sticker" ? (
      <div className="grid grid-cols-8 md:grid-cols-4 gap-1.5" data-testid="draw-stickers">
        {STICKERS.map((s) => (
          <button key={s} data-testid={`draw-sticker-${s}`} onClick={() => setSticker(s)} className={`h-12 rounded-xl text-2xl ${sticker === s ? "bg-amber-200 ring-2 ring-amber-500" : "bg-[#FFF5E8]"}`}>{s}</button>
        ))}
      </div>
    ) : (
      <div className="grid grid-cols-8 md:grid-cols-4 gap-1.5" data-testid="draw-palette">
        {PALETTE.map((c) => (
          <button key={c} data-testid={`draw-color-${c.slice(1)}`} onClick={() => setColor(c)} aria-label={c}
            className={`h-11 rounded-full border-2 transition-transform ${color === c ? "scale-110 ring-4 ring-[#E2683C]/50 border-white" : "border-stone-200"}`} style={{ background: c }} />
        ))}
      </div>
    )}
    <div className="flex gap-2" data-testid="draw-sizes">
      {SIZES.map(([v, label]) => (
        <button key={v} data-testid={`draw-size-${v}`} onClick={() => setSize(v)}
          className={`flex-1 h-12 rounded-2xl flex items-center justify-center gap-2 font-bold ${size === v ? "bg-stone-800 text-white" : "bg-[#FFF5E8] text-stone-700"}`}>
          <span className="rounded-full bg-current" style={{ width: v / 2.5 + 4, height: v / 2.5 + 4 }} />{label}
        </button>
      ))}
    </div>
  </div>
);
